import Marquee from "react-fast-marquee";

const TOKENS = [
  "$300M+ ATTRIBUTABLE REVENUE",
  "$5M MONTHLY SPEND",
  "300–450% ROAS",
  "40+ COUNTRIES",
  "FINTECH · TRADING · eCOMMERCE",
  "GOOGLE · META · BING · TIKTOK · DV360",
  "CAPI · GA4 · POWER BI",
  "DBA (AI/ML) · ACIM · UT AUSTIN",
];

export default function EditorialMarquee() {
  return (
    <section
      className="relative py-10 md:py-14 border-y border-stroke bg-obsidian"
      data-testid="marquee-section"
      aria-label="Metrics marquee"
    >
      <Marquee gradient={false} speed={38} pauseOnHover>
        {TOKENS.map((t) => (
          <div key={t} className="flex items-center pr-12 md:pr-20">
            <span className="text-laser text-2xl md:text-3xl leading-none mr-6 md:mr-10">✱</span>
            <span className="font-serif italic font-light text-ink text-3xl md:text-5xl lg:text-6xl tracking-tight">
              {t}
            </span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
